import { Injectable } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Effect, Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';
import * as fromRoot from '@app/core/store/actions/router.actions';
import * as DashboardActions from '../actions/dashboard.actions';
import { DashboardService } from '../../data/dashboard.service';
import { NotificationService } from '@app/shared/services/notification.service';
import { FileService } from '../../data/file.service';

@Injectable()
export class DashboardEffects {
  constructor(private actions$: Actions,
    private dashboardService: DashboardService,
    private notificationService: NotificationService,
    private fileService: FileService,
  ) { }


  @Effect()
  loadDashboardRequests$ = this.actions$.ofType(DashboardActions.DashboardAction.DashboardRequests).pipe(
    map((action: DashboardActions.DashboardRequests) => action.payload),
    switchMap(pagination => {
      return this.dashboardService
        .getDashboardRequests(pagination)
        .pipe(
          map(EventRequestModel => new DashboardActions.DashboardRequestsSuccess(EventRequestModel)),
          catchError(error => of(new DashboardActions.DashboardRequestsFail(error)))
        );
    })
  );


  @Effect()
  LoadPushedAnnouncements$ = this.actions$.ofType(DashboardActions.DashboardAction.LoadPushedAnnouncements).pipe(
    switchMap(() => {
      return this.dashboardService
        .getPushedAnnouncements()
        .pipe(
          map(roles => new DashboardActions.LoadPushedAnnouncementsSuccess(roles)),
          catchError(error => of(new DashboardActions.LoadPushedAnnouncementsFail(error)))
        );
    })
  );

  @Effect()
  AddAnouncementFeedbac$ = this.actions$.ofType(DashboardActions.DashboardAction.AddFeedback).pipe(
    map((action: DashboardActions.AddFeedback) => action.payload),
    switchMap(payload => {
      return this.dashboardService
        .addFeedbackFunction(payload.id, payload.comments)
        .pipe(
          map(request => {
            this.notificationService.success(`Your feedback has been added successfully`);
            return new fromRoot.Go({
              path: ['/announcement/feedback-list'],
            });
          }),
          catchError(error => of(new DashboardActions.AddFeedbackFail(error)))
        );
    })
  );

  @Effect()
  LoadUpcomingMeetings$ = this.actions$.ofType(DashboardActions.DashboardAction.LoadUpcomingMeetings).pipe(
    map((action: DashboardActions.LoadUpcomingMeetings) => action.payload),
    switchMap(pagination => {
      return this.dashboardService
        .getUpcomingMeetings(pagination)
        .pipe(
          map(requestVenues => new DashboardActions.LoadUpcomingMeetingsSuccess(requestVenues)),
          catchError(error => of(new DashboardActions.LoadUpcomingMeetingsFail(error)))
        );
    })
  );

  @Effect()
  LoadUpcomingEvents$ = this.actions$.ofType(DashboardActions.DashboardAction.LoadUpcomingEvents).pipe(
    map((action: DashboardActions.LoadUpcomingEvents) => action.payload),
    switchMap(pagination => {
      return this.dashboardService
        .getUpcomingEvents(pagination)
        .pipe(
          map(events => new DashboardActions.LoadUpcomingEventsSuccess(events)),
          catchError(error => of(new DashboardActions.LoadUpcomingEventsFail(error)))
        );
    })
  );

  @Effect()
  LoadAllRequests$ = this.actions$.ofType(DashboardActions.DashboardAction.LoadAllRequests).pipe(
    switchMap(() => {
      return this.dashboardService
        .getAllRequests()
        .pipe(
        map(requests => new DashboardActions.LoadAllRequestsSuccess(requests)),
        catchError(error => of(new DashboardActions.LoadAllRequestsFail(error)))
        );
    })
  );

  @Effect()
  LoadResourceCenter$ = this.actions$.ofType(DashboardActions.DashboardAction.LoadResourceCenter)
    .switchMap(() => {
      return this.fileService.GetResourceCenterFiles()
        .map(Files => new DashboardActions.LoadResourceCenterSuccess(Files))
        .catch(error => of(new DashboardActions.LoadResourceCenterFail(error)))
    });



  @Effect({ dispatch: false })
  LoadResourceCenterFail$ = this.actions$.ofType(DashboardActions.DashboardAction.LoadResourceCenterFail).pipe(
      map((action: DashboardActions.LoadResourceCenterFail) => action.payload),
    map(error => {
      this.notificationService.error(error);
    })
  );
}



// WEBPACK FOOTER //
// ./src/app/core/store/effects/dashboard.effects.ts